import { useMemo } from 'react';
import { useCategoryAutoComplete } from './useCategoryAutoComplete';
import { CATEGORY_LIST_KEYS } from '../../../constants';
import { CategoryData, CategoryList, CurrentCategory } from '../models';

type UseCategoryAutoCompleteAllProps = {
  listKey: string;
  isOpened: { id: number; listKey: string; } | null;
  srId: number;
  filteredCategoryList: CategoryList;
  primaryCategory: CurrentCategory;
  secondaryCategory: CurrentCategory;
  handleChange: (category: CategoryData) => void;
  delay: number;
};

export const useCategoryAutoCompleteAll = ({
  listKey,
  isOpened,
  srId,
  filteredCategoryList,
  primaryCategory,
  secondaryCategory,
  handleChange,
  delay,
}: UseCategoryAutoCompleteAllProps): void => {
  const { shouldTriggerSecondaryAutoComplete, shouldTriggerThirdAutoComplete } = useMemo(() => {
    const baseValidation = 
      isOpened?.id === srId && 
      isOpened?.listKey === listKey &&
      primaryCategory?.value &&
      filteredCategoryList?.length === 1;

    return {
      shouldTriggerSecondaryAutoComplete: 
        Boolean(baseValidation && listKey === CATEGORY_LIST_KEYS.SECONDARY_LEVEL_KEY),
      shouldTriggerThirdAutoComplete: 
        Boolean(baseValidation && listKey === CATEGORY_LIST_KEYS.THIRD_LEVEL_KEY && secondaryCategory?.value)
    };
  }, [
    isOpened?.id, 
    isOpened?.listKey, 
    srId, 
    listKey, 
    primaryCategory?.value, 
    filteredCategoryList?.length,
    secondaryCategory?.value
  ]);

  // Auto-complete for second level category
  useCategoryAutoComplete({
    shouldTriggerAutoComplete: shouldTriggerSecondaryAutoComplete,
    categoryToSelect: shouldTriggerSecondaryAutoComplete ? filteredCategoryList[0] : null,
    handleChange,
    delay,
  });

  // Auto-complete for third level category
  useCategoryAutoComplete({
    shouldTriggerAutoComplete: shouldTriggerThirdAutoComplete,
    categoryToSelect: shouldTriggerThirdAutoComplete ? filteredCategoryList[0] : null,
    handleChange,
    delay,
  });
}; 